import React, { Component } from "react"
import { navigate } from "gatsby"
import { AppContext } from "../context/context"
import { isBrowser } from "../services/firebase"

export class BlogTagLinks extends Component {
  tagClicked = tag => {
    if (isBrowser && this.context.isAuthenticated) {
      navigate("/app/opportunities", { state: { filter: tag } })
    } else {
      navigate("/app/signup", {
        state: {
          signupPayload: {
            message: `Sign up to see sponsorship opportunities with the tag "${tag}"`,
          },
        },
      })
    }
  }

  render() {
    return this.props.tags && this.props.tags.length ? (
      <div className="buttons">
        {this.props.tags.map(tag => (
          <button
            className="button is-small is-rounded is-outlined"
            key={tag + `tag`}
            onClick={() => this.tagClicked(tag)}
          >
            {tag}
          </button>
        ))}
      </div>
    ) : null
  }
}

BlogTagLinks.contextType = AppContext
export default BlogTagLinks
